/* Sop. Essential · Promo tapones regalo (snippets/sop-promo-tapones.liquid) · vanilla, sin dependencias
 * - Ficha Sop (sop-pdp): los valores van en inputs ocultos properties[...] del formulario del tema y
 *   la validación es la de sop-pdp.js (campos [data-sp-field][data-required]).
 * - Kit AM6 (sop-kit-configurator): se engancha a SopKit.Kit (faltan / propiedades / resumen del paso 6).
 * Cárgalo DESPUÉS de sop-pdp.js o de sop-kit-4.js.
 */
(function () {
  'use strict';
  var PROP_SIZE = 'Tapones regalo - medida';
  var PROP_COLOR = 'Tapones regalo - color';

  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function hex2(n) { return ('0' + Math.round(n).toString(16)).slice(-2); }
  function hsl2hex(h, s, l) {
    s /= 100; l /= 100;
    var a = s * Math.min(l, 1 - l);
    function f(n) { var k = (n + h / 30) % 12; return 255 * (l - a * Math.max(-1, Math.min(k - 3, 9 - k, 1))); }
    return ('#' + hex2(f(0)) + hex2(f(8)) + hex2(f(4))).toUpperCase();
  }

  function Promo(el) {
    this.el = el;
    this.size = '';
    this.color = '';
    this.hex = '';
    var self = this;
    el.addEventListener('change', function (e) {
      var t = e.target;
      if (!t.matches('[data-spt-pick]')) return;
      if (t.dataset.sptPick === 'size') self.size = t.value;
      else self.setColor(t.value);
      self.update(t.dataset.sptPick === 'size' ? 'promoSize' : 'promoColor');
    });
    // Valores marcados al volver atrás en el navegador
    $$(el, '[data-spt-pick]:checked').forEach(function (t) {
      if (t.dataset.sptPick === 'size') self.size = t.value; else self.setColor(t.value);
    });
    this.update(null, true);
  }

  Promo.prototype.setColor = function (v) {
    var picker = this.el.querySelector('[data-spt-picker]');
    if (v !== '__other') {
      this.color = v;
      if (picker) picker.hidden = true;
      return;
    }
    // "Otro color": la paleta sale directamente
    if (picker) {
      picker.hidden = false;
      if (!picker._pk) this.makePicker(picker);
    }
    this.color = 'Otro color: ' + (this.hex || '#1F4FB8');
  };

  // Paleta libre: misma pinta que la del Kit AM6 (clases .sk-picker de sop-kit.css)
  Promo.prototype.makePicker = function (box) {
    var self = this;
    box.innerHTML = '<div class="sk-picker">' +
      '<div class="sk-picker__top"><span class="sk-picker__swatch" data-pk-swatch></span>' +
      '<div><b data-pk-hex></b><small>Mueve las barras hasta dar con tu color.</small></div></div>' +
      '<label class="sk-picker__row"><span>Tono</span><input class="sk-range sk-range--hue" type="range" min="0" max="359" value="220" data-spt-pk="h" aria-label="Color de los tapones: tono"></label>' +
      '<label class="sk-picker__row"><span>Intensidad</span><input class="sk-range" type="range" min="0" max="100" value="70" data-spt-pk="s" aria-label="Color de los tapones: intensidad"></label>' +
      '<label class="sk-picker__row"><span>Luz</span><input class="sk-range" type="range" min="6" max="94" value="42" data-spt-pk="l" aria-label="Color de los tapones: luz"></label>' +
      '</div>';
    var r = {};
    $$(box, '[data-spt-pk]').forEach(function (i) { r[i.dataset.sptPk] = i; });
    function paint() {
      var h = +r.h.value, s = +r.s.value, l = +r.l.value, hx = hsl2hex(h, s, l);
      box.querySelector('[data-pk-swatch]').style.background = hx;
      box.querySelector('[data-pk-hex]').textContent = hx;
      r.s.style.background = 'linear-gradient(90deg,hsl(' + h + ',0%,' + l + '%),hsl(' + h + ',100%,' + l + '%))';
      r.l.style.background = 'linear-gradient(90deg,#000,hsl(' + h + ',' + s + '%,50%),#fff)';
      self.hex = hx;
      return hx;
    }
    box.addEventListener('input', function (e) {
      if (!e.target.matches('[data-spt-pk]')) return;
      e.stopPropagation(); // que el configurador no lo trate como uno de sus campos
      self.color = 'Otro color: ' + paint();
      self.update('promoColor');
    });
    box._pk = true;
    paint();
  };

  Promo.prototype.values = function () { return { size: this.size, color: this.color }; };
  Promo.prototype.missing = function () {
    var out = [];
    // solo se exige lo que se ve (un campo sin opciones en el editor no se pinta)
    if (!this.size && this.el.querySelector('[data-spt-field="size"]')) out.push({ step: 6, key: 'promoSize', label: 'medida de los tapones' });
    if (!this.color && this.el.querySelector('[data-spt-field="color"]')) out.push({ step: 6, key: 'promoColor', label: 'color de los tapones' });
    return out;
  };

  Promo.prototype.update = function (key, silent) {
    var el = this.el, v = this.values();
    $$(el, '[data-spt-out]').forEach(function (o) { o.value = v[o.dataset.sptOut] || ''; });
    $$(el, '[data-spt-val]').forEach(function (o) {
      var x = v[o.dataset.sptVal] || '';
      o.textContent = x.replace(/^Otro color: /, '');
    });
    // Foto del tapón: la zona dorada toma el color elegido (muestra o paleta)
    var pic = el.querySelector('.spt__pic--tint');
    if (pic) {
      var on = el.querySelector('[data-spt-pick="color"]:checked');
      var hx = on ? (on.value === '__other' ? this.hex : on.dataset.hex) : '';
      pic.classList.toggle('has-cap', !!hx);
      if (hx) pic.style.setProperty('--spt-cap', hx);
    }
    // Medida y color elegidos: mensaje de "ya son tuyos"
    var done = this.missing().length === 0, box = el.querySelector('[data-spt-done]');
    el.classList.toggle('is-done', done);
    if (box) {
      if (box.hidden === done) box.hidden = !done;
      box.querySelector('[data-spt-summary]').textContent = done
        ? [v.size, v.color.replace(/^Otro color: /, 'color ')].filter(Boolean).join(' · ') + '.'
        : '';
    }
    if (silent) return;
    var pdp = el.closest('[data-sp]'), kit = el.closest('[data-sk]');
    if (pdp && pdp._sp) {
      // quita el aviso rojo del campo ya elegido y actualiza la barra fija ("Falta: …")
      $$(el, '.sp-missing').forEach(function (b) {
        var out = b.querySelector('[data-spt-out]');
        if (out && out.value) {
          b.classList.remove('sp-missing');
          $$(b, '[aria-invalid]').forEach(function (f) { f.removeAttribute('aria-invalid'); });
        }
      });
      pdp._sp.renderStatus();
    } else if (kit && kit._sk && key) {
      kit._sk.after(key);
    }
  };

  // Aviso junto al precio: se coloca bajo la fila del precio de la ficha y lleva a la promo
  function placeTeaser(el) {
    var t = el.querySelector('[data-spt-teaser]');
    var root = el.closest('[data-sp], [data-sk]');
    var row = root && root.querySelector('.sk-head__row');
    if (!t || !row) return;
    row.insertAdjacentElement('afterend', t);
    t.hidden = false;
    if (t.tagName !== 'A') return; // Kit AM6: solo informa
    t.addEventListener('click', function (e) {
      e.preventDefault();
      setTimeout(function () {
        // por debajo de la vista previa fija del Kit AM6 o de la cabecera de la tienda
        var stage = root.querySelector('.sk-stage');
        var off = stage && getComputedStyle(stage).position === 'sticky' ? stage.offsetHeight + 8 : 90;
        window.scrollTo({ top: Math.max(0, el.getBoundingClientRect().top + window.scrollY - off), behavior: 'smooth' });
      }, 30);
    });
  }

  function promos(root) {
    return $$(root, '[data-spt]').map(function (el) { return el._spt; }).filter(Boolean);
  }

  // Kit AM6: la promo cuenta como parte del paso 6 (Revisa)
  function hookKit() {
    var S = window.SopKit;
    if (!S || !S.Kit || S.Kit.prototype._sptHooked) return;
    var K = S.Kit.prototype, baseMissing = K.missing, baseProps = K.properties, baseRows = K.summaryRows;
    K._sptHooked = true;
    K.missing = function () {
      var out = baseMissing.call(this);
      promos(this.root).forEach(function (p) { out = out.concat(p.missing()); });
      return out;
    };
    // Barra de progreso: los 2 campos de la promo cuentan en el total (si no, bajaría de 0 %)
    var baseRender = K.render;
    K.render = function () {
      baseRender.call(this);
      var n = $$(this.root, '[data-spt-field]').length, prog = this.root.querySelector('[data-sk-progress]');
      if (!n || !prog) return;
      var s = this.state, yes = s.igOn === 'SÍ';
      var total = 9 + (yes ? 1 : 0) - (yes && s.igSame ? 1 : 0) + n;
      var pct = Math.max(0, Math.round(((total - this.missing().length) / total) * 100));
      prog.setAttribute('aria-valuenow', pct);
      prog.firstElementChild.style.width = pct + '%';
    };
    // Paso 6: si solo falta la promo, llevamos al cliente a ella (está al final del paso)
    var baseNext = K.next;
    K.next = function () {
      var self = this;
      if (this.step === S.STEPS) {
        var miss = this.missing();
        if (miss.length && miss.every(function (m) { return /^promo/.test(m.key); })) {
          miss.forEach(function (m) { self.showErr(m.key, true); });
          this.toast('Te falta: ' + miss.map(function (m) { return m.label; }).join(', '));
          var box = this.root.querySelector('[data-err="' + miss[0].key + '"]');
          if (box) box.closest('.sk-group').scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
      }
      return baseNext.call(this);
    };
    if (baseProps) {
      K.properties = function () {
        var out = baseProps.call(this);
        promos(this.root).forEach(function (p) {
          var v = p.values();
          if (v.size) out.push([PROP_SIZE, v.size]);
          if (v.color) out.push([PROP_COLOR, v.color]);
        });
        return out;
      };
    }
    if (baseRows) {
      K.summaryRows = function () {
        var rows = baseRows.call(this);
        promos(this.root).forEach(function (p) {
          var v = p.values();
          rows.push([6, 'Tapones de regalo', v.size && v.color ? v.size + ' · ' + v.color.replace(/^Otro color: /, '') : '']);
        });
        return rows;
      };
    }
  }

  // Ficha Sop: la app King Product Options (YMQ) no envía el formulario del tema, sino su propia
  // petición a /cart/add con solo sus campos. Añadimos ahí la medida y el color de los tapones,
  // solo si la petición es para la variante de esta ficha y no los lleva ya (p. ej. product-form.js).
  function addPromoProps(body) {
    if (typeof FormData === 'undefined' || !(body instanceof FormData)) return;
    var el = document.querySelector('[data-spt][data-mode="pdp"]');
    if (!el || !el._spt) return;
    var out = el.querySelector('[data-spt-out]');
    var form = out && document.getElementById(out.getAttribute('form'));
    var idInput = form && form.querySelector('[name="id"]');
    if (!idInput || String(body.get('id')) !== String(idInput.value)) return;
    var v = el._spt.values();
    if (v.size && !body.has('properties[' + PROP_SIZE + ']')) body.append('properties[' + PROP_SIZE + ']', v.size);
    if (v.color && !body.has('properties[' + PROP_COLOR + ']')) body.append('properties[' + PROP_COLOR + ']', v.color);
  }
  function isCartAdd(url) { return /\/cart\/add(\.js)?(\?|$)/.test(String(url || '')); }
  function hookCartAdd() {
    if (window._sptCartHook || !document.querySelector('[data-spt][data-mode="pdp"]')) return;
    window._sptCartHook = true;
    var XHR = window.XMLHttpRequest && XMLHttpRequest.prototype;
    if (XHR) {
      var open = XHR.open, send = XHR.send;
      XHR.open = function (method, url) { this._sptUrl = url; return open.apply(this, arguments); };
      XHR.send = function (body) { if (isCartAdd(this._sptUrl)) addPromoProps(body); return send.apply(this, arguments); };
    }
    if (window.fetch) {
      var f = window.fetch;
      window.fetch = function (input, init) {
        if (init && isCartAdd(typeof input === 'string' ? input : input && input.url)) addPromoProps(init.body);
        return f.apply(this, arguments);
      };
    }
  }

  function init() {
    $$(document, '[data-spt]').forEach(function (el) {
      if (el._spt) return;
      el._spt = new Promo(el);
      placeTeaser(el);
    });
    hookCartAdd();
    hookKit();
    $$(document, '[data-sk]').forEach(function (el) { if (el._sk) el._sk.render(); });
    $$(document, '[data-sp]').forEach(function (el) { if (el._sp) el._sp.renderStatus(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // En el editor de temas: tras sop-pdp.js / sop-kit-4.js, que también escuchan este evento
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 0); });
})();
